<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';

</script>

<template>
    <PdfViewer title="返品ルール" :api-url=url.api.returnTerms.pdf :printable="false" />
</template>